import { pick } from './i18n.js';

const zh = {
  google: { cancelled: 'Google 登录已取消，可以重新登录。', denied: '此 Google 账号尚未开通访问权限，请联系管理员。', conflict: '此用户已绑定另一 Google 账号，请联系管理员核对。', expired: '这次 Google 登录未完成或已过期，请重新登录。', button: '使用 Google 账号登录', badUrl: 'Google 登录地址无效。', unavailable: 'Google 登录暂时不可用。' },
  heading: '连接 AiMo 执行端',
  loading: '正在读取设备授权请求…',
  pending: '确认后，这台设备归属当前账号，可用于你有权参与的所有项目。',
  processed: '这次设备授权已处理。请返回执行端查看结果，或重新发起登录。',
  switchAccount: '切换账号',
  invalidReturn: '执行端返回地址无效。',
  approved: '已授权，正在返回执行端…',
  denied: '已拒绝，正在返回执行端…',
  incomplete: '授权未完成，请重试。',
  approve: '允许连接',
  deny: '拒绝',
  unavailable: '授权请求不可用，请回到执行端重新登录。',
  expiresAt: (date: string) => '有效至 ' + date,
  account: (name: string, account: string) => '当前账号：' + name + '（' + account + '）',
};
const en: typeof zh = {
  google: { cancelled: 'Google sign-in was cancelled. You can sign in again.', denied: 'This Google account does not have access yet. Contact your administrator.', conflict: 'This user is already linked to another Google account. Contact your administrator.', expired: 'This Google sign-in did not finish or has expired. Please sign in again.', button: 'Sign in with Google', badUrl: 'The Google sign-in address is invalid.', unavailable: 'Google sign-in is unavailable right now.' },
  heading: 'Connect an AiMo execution device',
  loading: 'Loading device authorization request…',
  pending: 'Once confirmed, this device belongs to your account and can be used in every project you can access.',
  processed: 'This device authorization has been processed. Return to the execution device to check the result or sign in again.',
  switchAccount: 'Switch account',
  invalidReturn: 'The execution device return address is invalid.',
  approved: 'Authorized. Returning to the execution device…',
  denied: 'Denied. Returning to the execution device…',
  incomplete: 'Authorization did not complete. Try again.',
  approve: 'Allow connection',
  deny: 'Deny',
  unavailable: 'The authorization request is unavailable. Return to the execution device and sign in again.',
  expiresAt: (date: string) => 'Valid until ' + date,
  account: (name: string, account: string) => 'Current account: ' + name + ' (' + account + ')',
};
export const authFlowTextByLocale = { zh, en };
export const authFlowText = pick<typeof zh>(authFlowTextByLocale);
